import { BaseActionEnum } from "../../components/action-menu/ActionMenuItem";
import { getActionMenuItems } from "../../components/action-menu/BaseActions";

const objectActionEnums = [
    BaseActionEnum.Export,
    BaseActionEnum.Refresh,
    BaseActionEnum.DemandScan,
    BaseActionEnum.WriteDown,
    BaseActionEnum.AddMemo,
    BaseActionEnum.AddRunTicket,
    BaseActionEnum.SubmitWriteDown,
    BaseActionEnum.AddAttachment,
    BaseActionEnum.AddEvent,
    BaseActionEnum.AddDiagnositicEvent,
    BaseActionEnum.AddWaterLossEvent,
    BaseActionEnum.AddAttribute,
    BaseActionEnum.ShowDurationSettings,
    BaseActionEnum.ModifyPollingSchedule,
    BaseActionEnum.MapIt,
    BaseActionEnum.ManageComm,
    BaseActionEnum.DisableAllAlarms,
    BaseActionEnum.EnableAllAlarms,
    BaseActionEnum.Favorite,
];

export const objectActionItems = getActionMenuItems(objectActionEnums);
